import { PrimengModule } from './shared/primeng/primeng.module';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponentModule } from './shared/layout/layout.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { GlobalErrorHandler } from './core/errors/global-error-handler';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiModule, Configuration, ConfigurationParameters } from './core/api/v1';
import { environment } from '../config/environments/environment';
import { WithCredentialsInterceptor } from './core/interceptors/with-credentials.interceptor';
import { SessionExpirationInterceptor } from './core/interceptors/session-expiration.interceptor';
import { NgHttpLoaderComponent } from 'ng-http-loader';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { minditPreset } from 'src/config/presets/mindit';
import { ProbationNotificationsComponent } from './shared/components/probation-notifications/probation-notifications.component';

export const apiConfigFactory = (): Configuration => {
  const params: ConfigurationParameters = {
    basePath: `${environment.apiBaseURL}`
  };

  return new Configuration(params);
};

@NgModule({
  declarations: [AppComponent],
  exports: [PrimengModule],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LayoutComponentModule,
    ApiModule.forRoot(apiConfigFactory),
    PrimengModule,
    NgHttpLoaderComponent,
    ProbationNotificationsComponent
  ],
  providers: [
    MessageService,
    ConfirmationService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionExpirationInterceptor,
      multi: true
    },
    ConfirmationService,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: minditPreset,
        options: {
          prefix: 'p',
          darkModeSelector: 'system',
          cssLayer: false
        }
      }
    })
  ] })
export class AppModule { }
